import script from "./WOIframe.vue?vue&type=script&setup=true&lang=ts"
export * from "./WOIframe.vue?vue&type=script&setup=true&lang=ts"

import "./WOIframe.vue?vue&type=style&index=0&id=3119a102&lang=less&scoped=true"
import "./WOIframe.vue?vue&type=style&index=1&id=3119a102&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3119a102"]])

export default __exports__